export default "/images/exhibition-banner.png?1ba7f5ee081a205a3ebbfb797b07d0fe";